import React from "react";
import { subscribeMercado } from "~/redux/user/actions";
import store from "~/redux/user/store";
import { pushFinishSubscriptionEvent } from "~/services/analyticsService";
import PropTypes from "prop-types";
import "./style.scss";
import BankSelect from "./BankSelect";
import { validateCustomerCard } from '~/services/userService';
import verifiedImg from '~/assets/images/verified.png';
import CardIcon from '~/assets/images/card-icon.png';
import { subscribe } from '~/redux/user/subscription';
import Paypal from '~/components/Paypal'
//https://www.mercadopago.com.mx/developers/en/guides/payments/api/receiving-payment-by-card
class MercadoForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			cardNumber: "",
			paymentMethodId: "",
			errors: [],
			loading: false,
			issuers: [],
			issuerId: ""
		};
		this.checkout = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.sdkResponseHandler = this.sdkResponseHandler.bind(this);
	}

	componentDidMount() {
		let script = document.createElement("script");
		script.onload = function() {
			window.Mercadopago.setPublishableKey(
				window.settings.paymentProviders.mercadopago.apikey
			);
		};
		script.src = "https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js";
		document.head.appendChild(script);
	}

	handleSubmit(event) {
		event.preventDefault();
		const form = this.checkout.current;
		this.setState({ loading: true });
		window.Mercadopago.createToken(form, this.sdkResponseHandler);
	}

	handleChange(event) {
		if (event.target.name)
			this.setState(
				Object.assign({}, this.state, {
					[event.target.name]: event.target.value
				})
			);
		else if (event.target.id) {
			this.setState(
				Object.assign({}, this.state, { [event.target.id]: event.target.value })
			);
		}
	}

	guessPaymentMethod(event) {
		const value = event.target.value.replace(" ","");
		this.setState({
			cardNumber: value
		})
		if (value.length >= 6 && !this.state.paymentMethodId) {
			window.Mercadopago.getPaymentMethod(
				{ bin: value },
				(status, response) => {
					if (status === 200 && response) {
						this.setState({ paymentMethodId: response[0].id });
						this.setPaymentMethodInfo(value, 1);
					} else {
						this.setState({ paymentMethodId: "" });
					}
				}
			);
		} else if (value.length < 6 && this.state.paymentMethodId) {
			this.setState({ 
				paymentMethodId: "",
				issuers: [],
				issuerId: "" 
			});
		}
	}
	setPaymentMethodInfo(bin, amount) {
		window.Mercadopago.getInstallments(
			{ bin: bin, amount: amount },
			(status, response) => {
				if (status === 200 && response) {
					if (response.length === 1) {
						this.setState({ issuerId: response[0].issuer.id });
						this.setState({ issuers: response });
					} else if (response.length > 1) {
						this.setState({ issuers: response });
					}
				}
			}
		);
	}
	async sdkResponseHandler(status, response) {
		if (response.error) {
			this.setState({
				errors: response.cause.map(c => c.description),
				loading: false
			});
			return;
		}
		try {
			const site = window.settings.internalName;
			const publishableKey = window.settings.paymentProviders.mercadopago.apikey;
			const paymentMethodId = this.state.paymentMethodId;
			const issuerId = this.state.issuerId;
			const email = this.state.email;
			const {id, userId, first_six_digits} = response;
			const validation = await validateCustomerCard(id, site, email, userId, publishableKey, paymentMethodId, issuerId);
			if(validation.status < 300){
				store
					.dispatch(
						subscribeMercado({
							firstSixDigits: first_six_digits,
							email: email,
							plan: this.props.plan,
							id: id,
							issuerId: issuerId,
							paymentMethodId: paymentMethodId,
							publishableKey: publishableKey
						})
					)
					.then(res => {
						pushFinishSubscriptionEvent(this.props.plan);
						this.setState({ loading: false });
						this.props.success();
					});
			} else {
				if(validation.data && validation.data.error){
					this.setState({
						errors: [validation.data.error],
						loading: false
					});
				}
				return;
			}
		} catch (e) {
			console.log(e);
		}
	}

	generateYearList = (currentYear) => {
		let yearList = [];
		for(let i = 0; i < 21; i++){
			yearList.push(currentYear + i);
		}
		return yearList;
	}

	displayContainers(filteredHandlers, handlersMap) {
		const isMercadoLoading = this.props.loading
		return filteredHandlers.map((key, i) => {
		  const lowKey = key.toLowerCase() 
		  const paymentId = lowKey === 'paypal' ? 'vlTransactionId' : 'paymentUniqueId'
		  const Handler = handlersMap[lowKey]
		  return (
			<Handler
			  key={i}
			  disabled={isMercadoLoading}
			  style={{ marginBottom: '10px' }}
			  currentPlan={this.props.plan}
			  overlay={this.props.overlay}
			  subscribe={(id) => subscribe({  
				[paymentId]: id,
				subscription: lowKey,
				plan: this.props.plan, 
				offerCode:
				  this.props.offerCode &&
				  this.props.offerCode.code
			  }).then(data => this.props.success(data))}
			/>
		  ) 
		})
	  }

	render() {
		const currentYear = new Date().getFullYear();
		const yearList = this.generateYearList(currentYear);
		const monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
		let handlersMap = {
			paypal: Paypal
		}
		if (this.props.type && (this.props.type.toLowerCase() === "ppv" || this.props.type.toLowerCase() === "svod+ppv")) {
			handlersMap = {}
		}

		const filteredHandlers = Object.keys(window.settings.paymentProviders).filter(f => { 
			return Object.keys(handlersMap).includes(f.toLowerCase())
		})

		return (
			<form
				id="pay"
				name="pay"
				className="cc-form mercado-form"
				onSubmit={this.handleSubmit}
				ref={this.checkout}
			>
				<ul className="error-list">
					{this.state.errors.map(e => {
						return (
							<li key={e} className="error">
								{e}
							</li>
						);
					})}
				</ul>
				<div className="left-form">
					<div className="title">{this.props.metadataMap.billingInfoHead}</div>
					<div className="our-input">
						<input
							className="form-control"
							type="text"
							id="cardholderName"
							data-checkout="cardholderName"
							placeholder={this.props.metadataMap.nameOnCard}
						/>
					</div>
					<div className="our-input">
						<input
							className="form-control"
							id="email"
							name="email"
							type="text"
							value={this.state.email}
							onChange={this.handleChange}
							autoComplete="off"
							placeholder={this.props.metadataMap.createAccountEmail}
						/>
					</div>
					<div className="our-input">
						<label className="title">{"Doc. Type"}</label>
						<div className="input-group">
							<select
								id="docType"
								className="custom-select"
								data-checkout="docType"
								value={this.state.docutype}
								name="docutype"
								onChange={this.handleChange}
							>
								<option value="DNI">DNI</option>
								<option value="CI">Cédula</option>
								<option value="LC">L.C.</option>
								<option value="LE">L.E.</option>
							</select>
						</div>
					</div>
					<div className="our-input">
						<input
							className="form-control"
							type="text"
							id="docNumber"
							data-checkout="docNumber"
							placeholder={this.props.metadataMap.docNumber}
							autoComplete="off"
						/>
					</div>
					<div className="verification-banner">
						<img alt="Verification" src={ verifiedImg } role="presentation" />
					</div>
				</div>
				<div className="right-form">
					<div className="title">{this.props.metadataMap.cardDetailsHeading}</div>
					<div className="our-input">
						<input
							className="form-control"
							type="text"
							id="cardNumber"
							data-checkout="cardNumber"
							placeholder={this.props.metadataMap.cardNumber}
							name="cardNumber"
							value={this.state.cardNumber}
							onChange={e => {
								this.guessPaymentMethod(e);
							}}
							onPaste={(e)=>{e.preventDefault()}}
							maxlength="16"
						/>
					</div>
					<div className="flex-row">
						<div className="our-input month-select">
							<select
								id="cardExpirationMonth"
								className="custom-select"
								data-checkout="cardExpirationMonth"
								value={this.state.cardExpirationMonth}
								defaultValue="default"
								onChange={this.handleChange}
							>
								<option value="default" disabled>{this.props.metadataMap.ccExpirationMonth}</option>
								{monthList.map(month=>{
									return <option value={month}>{month}</option>
								})}
							</select>
						</div>
						<div className="our-input">
							<select
								id="cardExpirationYear"
								className="custom-select"
								data-checkout="cardExpirationYear"
								value={this.state.cardExpirationYear}
								defaultValue="default"
								onChange={this.handleChange}
							>
								<option value="default" disabled>{this.props.metadataMap.ccExpirationYear}</option>
								{yearList.map(year=>{
									return <option value={year}>{year}</option>
								})}
							</select>
						</div>
					</div>
					<div className="flex-row">
						{this.state.issuers.length > 1 && (
							<div className="our-input bank-select">
								<BankSelect
									issuers={this.state.issuers}
									handleOnChange={e => {
										this.setState({ issuerId: e.target.value });
									}}
								/>
							</div>
						)}
						<div className="our-input">
							<input
								className="form-control"
								type="text"
								id="securityCode"
								data-checkout="securityCode"
								placeholder={this.props.metadataMap.cvc}
								maxlength="4"
							/>
							<img className="card-icon" src={CardIcon} alt="card icon"/>
						</div>
					</div>
					<input
						type="hidden"
						name="paymentMethodId"
						value={this.state.paymentMethodId}
					/>
					<input
						className="btn btn-primary continue-button"
						type="submit"
						value={this.props.metadataMap.billingSubscribeNow}
						disabled={this.state.loading}
					/>
					{ (filteredHandlers.length > 0) && 
						<React.Fragment>
							<span className='or-handlers'>Or</span> 
						<React.Fragment>
							{ this.displayContainers(filteredHandlers, handlersMap) }
						</React.Fragment>
						</React.Fragment> 
					}
				</div>
				<div className="legal-texts">
					{this.props.metadataMap.verifyLegalText}
				</div>
			</form>
		);
	}
}
MercadoForm.propTypes = {
	success: PropTypes.func.isRequired,
	plan: PropTypes.object.isRequired
};
export default MercadoForm;
